import React from 'react';

const LoadingSpinner = ({ size = 'medium' }) => {
  // Size variants
  const sizeClasses = {
    small: 'w-4 h-4 border-2',
    medium: 'w-8 h-8 border-4',
    large: 'w-12 h-12 border-4'
  };
  
  return (
    <div className="flex justify-center items-center">
      <div className={`${sizeClasses[size]} rounded-full border-t-primary border-r-transparent border-b-transparent border-l-transparent animate-spin`}></div>
    </div>
  );
};

export default LoadingSpinner;